import { events, parseOrderForAnalytics } from '@waybetter/wb-analytics';

import { appendGameUrl } from './append-game-url';

export const trackStartMembershipOrder = ({ gameId, order, userId }) => {
  order.orderItems = appendGameUrl(order.orderItems);

  const analyticsOrder = parseOrderForAnalytics({
    user: { id: userId },
    game: { id: gameId },
    order,
    appName: 'hub',
    referringGameId: gameId,
    decamelize: true,
  });

  analytics.track(events.CHECKOUT_STARTED, analyticsOrder);
};
